import axios from 'axios'
import { reset } from 'redux-form'
import _ from 'lodash'
import v4 from 'uuid/v4'
import { toastr } from 'react-redux-toastr'
import actions from './actions'

const timeGif = [
  0,
  920,
  1960,
  1840,
  1840,
  2360,
  2360,
]

const getIpAddress = () => (dispatch) => {
  dispatch(actions.getIpAddressRequest())
  return axios({
    url: 'https://api.ipify.org?format=json',
    method: 'get',
    contentType: 'application/json',
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(actions.getIpAddressSuccess(res.data))
      } else {
        dispatch(actions.getIpAddressFailure())
        toastr.error(
          'Vous n\'avez pas pu être locaslisé',
          'Veuillez recharger la page',
        )
      }
    })
    .catch((err) => {
      dispatch(actions.getIpAddressFailure(err))
      toastr.error(
        'Vous n\'avez pas pu être locaslisé',
        'Veuillez recharger la page',
      )
    })
}

const sendMessage = (sessionToken, params, conversationId) => (dispatch) => {
  if (_.trim(params.text) === '') {
    return
  }
  dispatch(actions.postMessageRequest({
    userMessage: params.text,
    id: v4(),
  }))
  dispatch(reset('userInput'))
  return axios({
    url: `https://directline.botframework.com/v3/directline/conversations/${conversationId}/activities`,
    method: 'post',
    contentType: 'application/json',
    headers: { authorization: `Bearer ${sessionToken}` },
    data: {
      ...params,
      userAgent: window.navigator.userAgent,
    },
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(actions.postMessageSuccess({
          userMessage: params.text,
          id: v4(),
        }))
      } else if (res.status === 403) {
        window.location.reload()
        dispatch(actions.postMessageFailure({ userMessage: params.text }))
      } else {
        toastr.error(
          'Votre message n\'a pu être envoyé',
          'Veuillez recharger la page',
        )
        dispatch(actions.postMessageFailure({ userMessage: params.text }))
      }
    })
    .catch((err) => {
      toastr.error(
        'Votre message n\'a pu être envoyé',
        'Veuillez recharger la page',
      )
      dispatch(actions.postMessageFailure(err))
    })
}

const sendQuickReply = (botConfig, value, data, userId, ipAddress) => (dispatch) => {
  dispatch(actions.postQuickReplyRequest({
    userMessage: data.content,
    id: v4(),
  }))
  return axios({
    url: `https://directline.botframework.com/v3/directline/conversations/${botConfig.conversationId}/activities`,
    method: 'post',
    contentType: 'application/json',
    headers: { authorization: `Bearer ${botConfig.sessionToken}` },
    data: {
      from: {
        id: userId,
        ipAddress,
      },
      text: value,
      type: 'message',
    },
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch(actions.postQuickReplySuccess())
      } else if (res.status === 403) {
        window.location.reload()
      } else {
        dispatch(actions.postQuickReplyFailure(data.content))
      }
    })
    .catch((err) => {
      console.error(err);
      dispatch(actions.postQuickReplyFailure(data.content))
    })
}

const receiveData = data => (dispatch) => {
  const conversation_page = (_.get(data, 'activities.0.entities.0.conversation_page'))
  if (conversation_page) window.sendTracker(conversation_page)
  dispatch(actions.receiveData(data))
}

const storeBotData = actions.storeBotData
const setEmotion = (data, prevEmotion) => (dispatch) => {
  const newEmotion = (_.get(data, 'activities.0.entities.0.emotion', 1))
  if (newEmotion === prevEmotion || !newEmotion || newEmotion === 1) {
    return
  }
  const emotionDuration = (_.get(data, 'activities.0.entities.0.emotion.duration', timeGif[newEmotion]))
  setTimeout(() => {
    dispatch(actions.setEmotion('/img/bot_gif/emotion_1.gif'))
  }, emotionDuration)
  dispatch(actions.setEmotion(`/img/bot_gif/emotion_${newEmotion}.gif`))
}

export default {
  getIpAddress,
  sendMessage,
  receiveData,
  sendQuickReply,
  storeBotData,
  setEmotion,
}



// WEBPACK FOOTER //
// ./src/redux/operations.js